import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaSignOutAlt, FaExternalLinkAlt, FaBell, FaUser } from 'react-icons/fa';
import { useAdmin } from '../context/AdminContext';
import './TopBar.css';

const TopBar = ({ toggleSidebar }) => {
  const { logout, data, user } = useAdmin();
  const navigate = useNavigate();

  // 1. Calculate New Inquiries safely (Case-insensitive)
  const newInquiriesCount = (data?.inquiries || []).filter(
    (i) => (i.status || '').toLowerCase() === 'new'
  ).length;

  // 2. Dynamic User Profile Info from Backend/Context
  const displayName =
    user?.full_name ||
    user?.username ||
    user?.email ||
    data?.header?.user_name ||
    'Admin User';

  const displayRole =
    user?.role ||
    (user?.is_superuser ? 'Super Admin' : 'Admin');

  // 3. Logout Handler
  const handleLogout = () => {
    logout();
    navigate('/admin/login'); // Or your login route
  };

  return (
    <header className="admin-topbar">
      <div className="topbar-left">
        <button className="topbar-toggle" onClick={toggleSidebar} title="Toggle Sidebar">
          <FaBars />
        </button>
        <h1 className="topbar-title">Admin Dashboard</h1>
      </div>

      <div className="topbar-right">
        {/* View Public Website */}
        <Link to="/" target="_blank" className="topbar-link" title="View Public Website">
          <FaExternalLinkAlt />
          <span>View Site</span>
        </Link>


        {/* Logged-in User Profile */}
        <div className="topbar-profile">
          <div className="profile-avatar">
            {displayName ? displayName.charAt(0).toUpperCase() : <FaUser />}
          </div>
          <div className="profile-info">
            <strong>{displayName}</strong>
            <span>{displayRole}</span>
          </div>
        </div>

        {/* Logout Button */}
        <button className="topbar-logout" onClick={handleLogout} title="Logout">
          <FaSignOutAlt />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default TopBar;